<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
    <div class="f">
      <el-date-picker
        v-model="dateValues"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin-right: 10px"
        @change="timeChange"
        :clearable="false"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <!-- <el-button @click="dashboardImportExportFile">导出</el-button> -->
    </div>
    <el-table
      :data="listData"
      @sort-change="sortTable"
      style="width: 100%"
      :key="visitorData.type"
    >
      <el-table-column type="index" width="50"></el-table-column>
      <template v-if="visitorData.type && visitorData.type.includes('visitor')">
        <el-table-column :label="visitorData.type === 'visitor' ? '来源' : '国家/地区'" property="name" min-width="250"></el-table-column>
        <el-table-column label="访客数" prop="visitorQty" sortable="custom" min-width="150"></el-table-column>
        <el-table-column label="比率" min-width="150">
          <template slot-scope="scope">
            <el-progress
              :text-inside="true"
              :stroke-width="26"
              :percentage="scope.row.rate*100 | round"
            ></el-progress>
          </template>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column
          v-if="visitorData.type === 'banner'"
          label="Banner图"
          min-width="150">
          <template v-slot="{ row }">
            <el-popover placement="right" width="340" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" style="width: 60px;height: 35px" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="visitorData.type === 'product_like'"
          label="产品信息"
          min-width="200">
          <div slot-scope="{row}" class="f--c">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" style="width: 36px;height: 36px" />
            </el-popover>
            <div style="width:100%;margin-left:10px">
              <el-tooltip class="item" effect="dark" :content="row.productName" placement="top">
                <div style="width:80%;font-size: 14px" class="ellipsis">{{ row.productName }}</div>
              </el-tooltip>
              <div style="font-size: 12px;color: #454545;">
                SPU：
                <copy :text="row.spuCode" />
              </div>
            </div>
          </div>
        </el-table-column>
        <el-table-column
          v-else
          prop="name"
          label="名称"
          min-width="150">
          <template v-slot="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.name" placement="top">
              <div style="width:90%;font-size: 14px" class="ellipsis">{{ row.name }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            prop="browseQty"
            label="浏览量"
            min-width="76"
            align="right"
            sortable="custom">
          </el-table-column>
          <el-table-column
            prop="clickQty"
            label="点击量"
            min-width="76"
            align="right"
            sortable="custom">
          </el-table-column>
          <el-table-column
            prop="rate"
            label="点击率"
            min-width="70"
            align="right"
            sortable="custom">
            <div slot-scope="{row}" class="f-e-c">
              {{ row.rate*100 | round }}%
            </div>
          </el-table-column>
      </template>
    </el-table>
    <div class="f-b-c" style="margin-top:10px">
      <div></div>
      <el-pagination
        background
        layout="total,prev, pager, next"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        :total="total"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import API from "@/api";
import { dateFormat } from '@/utils/date'
import moment from "moment";
import copy from '@/components/copy.vue'
export default {
  components: { copy },
  data() {
    return {
      dialogTableVisible: false,
      dialogTitle: '',
      listData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      dateValues: [moment().subtract("days", 6), moment()],
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setHours(0, 0, 0, 0), start.setHours(23, 59, 59, 999));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date().setHours(23, 59, 59, 999) - 24 * 3600000;
            const start = new Date().setHours(0, 0, 0, 0) - 24 * 3600000;
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近七天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick(picker) {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime();
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getTime() + 24 * 3600000 - 60;
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999);
        },
      },
      visitorData: {},
    };
  },
  computed: {
      getSortType() {
        return (type) => {
          switch (type) {
            case 'ascending':
              return 'asc'
            case 'descending':
              return 'desc'
            case null:
              return undefined
          }
        }
      },
      getSortName() {
        return (name) => {
          switch (name) {
            case 'browseQty':
              return 1
            case 'clickQty':
              return 2
            case 'rate':
              return 3
            case null:
              return undefined
          }
        }
      }
    },
  methods: {
    showTable(e) {
      this.dialogTitle = `${e.title}详情`;
      this.dateValues = [Number(e.chartTime[0]), Number(e.chartTime[1])];
      this.$set(this.params, 'startTime', dateFormat(e.chartTime[0], 'yyyy-MM-dd').replace(/-/g, ''))
      this.$set(this.params, 'endTime', dateFormat(e.chartTime[1], 'yyyy-MM-dd').replace(/-/g, ''))
      this.$set(this.$data, "visitorData", e);
      if (e.type.includes('visitor')) this.$set(this.params, 'sourceType', e.type === 'visitor' ? 2 : 1)
      else this.$set(this.params, 'type', e.type === 'banner' ? 1 : e.type === 'category' ? 2 : e.type === 'activity' ? 3 : e.type === 'product_like' ? 4 : '')
      this.dialogTableVisible = true;
      this.resetPage()
    },
    timeChange(value) {
      this.$set(this.params, 'startTime', (value && value.length === 2) ? dateFormat(value[0], 'yyyy-MM-dd').replace(/-/g, '') : undefined)
      this.$set(this.params, 'endTime', (value && value.length === 2) ? dateFormat(value[1], 'yyyy-MM-dd').replace(/-/g, '') : undefined)
      this.resetPage()
    },
    getList() {
      API[ this.visitorData.type.includes('visitor')?'dashboardVistiorDetails':'getDashboardDialog' ](this.params).then((res) => {
        this.listData = res.data.list;
        this.total = res.data.total;
      })
    },
    // dashboardImportExportFile() {
    //   let condition = {
    //     startPeriod: parseInt(
    //       this.dateValues[0].format("YYYY-MM-DD").split("-").join("")
    //     ),
    //     endPeriod: parseInt(
    //       this.dateValues[1].format("YYYY-MM-DD").split("-").join("")
    //     ),
    //     sourceType: this.type === "countrySort" ? 1 : 2,
    //   };
    //   condition = JSON.stringify(condition);
    //   const params = {
    //     fileType: 2,
    //     taskType: 6,
    //     condition,
    //   };
    //   API.dashboardImportExportFile(params)
    //     .then(() => {
    //       this.$message.success("操作成功，请到导入导出管理查看");
    //     })
    //     .catch((err) => {
    //       this.$message.error(err.data.message);
    //     });
    // },

    resetPage() {
      this.params.pageNumber = 1
      this.getList()
    },
    sizeChange(size) {
      this.params.pageSize = size
      this.getList()
    },
    //用户概览分页
    pageChange(page) {
      this.params.pageNumber = page
      this.getList()
    },
    sortTable({ prop, order }) {
      this.params.sortType = this.getSortName(prop)
      this.params.sort = this.getSortType(order)
      this.resetPage()
    }
  },
};
</script>

<style lang="scss" scoped>
.containter {
  width: 32%;
  min-width: 400px;
  padding: 20px;
  .top_title {
    > .font {
      font-weight: 600;
      height: 40px;
      line-height: 40px;
    }
  }
  .productInfo {
    > .label {
      height: 40px;
      line-height: 40px;
      > div {
        flex: 2;
      }
      .visitor {
        flex: 1;
        text-align: center;
      }
    }
    .info {
      margin-bottom: 10px;
      > div:first-of-type {
        width: 160px;
      }
      > div {
        flex: 2;
      }
      .visitor {
        flex: 1;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.haveSort {
  color: #58b1fd;
}
.el-icon-sort-up-me > div:after {
  content: "\e7c5";
}
.el-icon-sort-down-me > div::after {
  content: "\e7c4";
}
.el-icon-sort-me > div::after {
  content: "\e6d2";
}
</style>